import { useAccessibleCircles } from "./useAccessibleCircles";

export interface Subcircle {
  circleId: string;
  name: string;
  description: string;
  isPublic: boolean;
  isSubCircle: boolean;
  parentCircle?: string;
  memberCount: number;
  createdAt: string;
  createdBy: string;
  circleApproved: boolean;
  logo: string;
  type: string;
}

export const useSubcircles = () => {
  const { subcircles, isLoading, error, refetch } = useAccessibleCircles();

  return {
    subcircles: subcircles as Subcircle[],
    loading: isLoading,
    error,
    refetch,
  };
};
